import { render, staticRenderFns } from "./MyTodoForm.vue?vue&type=template&id=5e4d8fb6&scoped=true&"
import script from "./MyTodoForm.vue?vue&type=script&lang=js&"
export * from "./MyTodoForm.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoForm.vue?vue&type=style&index=0&id=5e4d8fb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d8fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e4d8fb6')) {
      api.createRecord('5e4d8fb6', component.options)
    } else {
      api.reload('5e4d8fb6', component.options)
    }
    module.hot.accept("./MyTodoForm.vue?vue&type=template&id=5e4d8fb6&scoped=true&", function () {
      api.rerender('5e4d8fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eletronicSigned/modules/MyTodoForm.vue"
export default component.exports